module.exports = __webpack_public_path__ + "img/35.cd532549.png";